import React from "react";
import { Link } from "react-router-dom";
import usePageTitle from "../../utils/usePageTitle";

// The server answers these URLs with a 404 status too (server.js), so they aren't indexed.
const NotFound = () => {
  usePageTitle("Хуудас олдсонгүй");
  return (
    <main className="not-found">
      <div className="not-found-card">
        <span className="dialog-icon" aria-hidden="true">
          <i className="fas fa-map-signs"></i>
        </span>
        <span className="not-found-code">Алдаа 404</span>
        <h1 className="not-found-title">Хуудас олдсонгүй</h1>
        <p className="not-found-lead">
          Таны хайсан хуудас байхгүй эсвэл зөөгдсөн байна. Хаягаа шалгаад дахин оролдоно уу.
        </p>

        <div className="not-found-actions">
          <Link to="/" className="button not-found-primary">
            <i className="fas fa-home" aria-hidden="true"></i>
            <span>Нүүр хуудас</span>
          </Link>
          <Link to="/templates" className="button not-found-secondary">
            Бэлэн загварууд
          </Link>
        </div>
      </div>
    </main>
  );
};

export default NotFound;
